import React, {Fragment} from "react";
import {DeserializedElementRule} from "../../slate/Transformation";
import {Editor, Range, Transforms} from "slate";
import {isKeyHotkey} from "is-hotkey";

export const Rules: {[key: string]: DeserializedElementRule<HTMLElement>} = {
    "br": {
        isVoid: () => true,
        tagType: () => 'inline',
        onKeyUp: (event, editor) => {
            const [component] = Editor.nodes(editor, {
                match: n => n.type === 'br',
            })
            //console.log(JSON.parse(JSON.stringify(editor.selection)));
            if (!!component) {
                if (!Range.isExpanded(editor.selection)) {
                    if (isKeyHotkey('arrowright')(event)) {
                        Transforms.move(editor, {});
                    } else if (isKeyHotkey('arrowleft')(event)) {
                        Transforms.move(editor, {reverse: true});
                    }
                } else {
                    /*let selection = {...editor.selection};
                    console.log(JSON.parse(JSON.stringify(selection)));
                    let start = Range.isBackward(editor.selection) ? 'focus' : 'anchor';
                    let end = Range.isBackward(editor.selection) ? 'anchor' : 'focus';
                    if (isKeyHotkey('arrowright')(event)) {
                        selection[end].path[1] += 1;
                    } else if (isKeyHotkey('arrowleft')(event)) {
                        selection[start].path[1] -= 1;
                    }
                    console.log(JSON.parse(JSON.stringify(selection)));
                    Transforms.select(editor, selection);*/
                }
            }
        },
        isActive: (editor) => {
            const [component] = Editor.nodes(editor, {
                match: n => n.type === 'br',
            })
            return !!component
        },
        match: (element) => element.type === 'br',
        hotKey: {generic: "shift+enter"},
        toggle: (editor) => {
            //let selection = editor.selection
            Transforms.insertNodes(
                editor,
                [{
                    type: 'br',
                    children: [{text: ''}]
                },{
                    text: ''
                }],
                {
                }
            );
            //Transforms.setSelection(editor, selection);
        },
        deserialize(el, next) {
            if (el.tagName?.toLowerCase() === 'br') {
                return [{
                    type: 'br',
                    props: {},
                    children: []
                },{
                    text: ''
                }];
            }
        },
        serialize(node, next) {
            if (node.type === 'br') {
                return <br/>;
            }
        },
        render: ({node}) => {
            return (node.element?.type === 'br' ? <Fragment><br {...node.attributes}/><span data-slate-spacer="true" style={{height: 0, color: "transparent", outline: "none", position: "absolute"}}>{node.children}</span></Fragment> : undefined);
        }
    }
};